export default __webpack_public_path__ + "static/media/landing page.75352d45.webp";